import * as React from "react"
import { Drawer as DrawerPrimitive } from "vaul"

import { APP_CONTENT_SHELL_CLASSNAME } from "@/shared/constants/layout"
import { VAUL_BOTTOM_SHEET_SAFE_OUTER_CLASSNAME } from "@/shared/lib/drawerContentSafeInsetStyle"
import { cn } from "@/shared/lib/utils"

type VaulBottomSheetShellProps = React.ComponentPropsWithoutRef<
  typeof DrawerPrimitive.Content
> & {
  panelClassName?: string
  panelStyle?: React.CSSProperties
}

export const VaulBottomSheetShell = React.forwardRef<
  React.ElementRef<typeof DrawerPrimitive.Content>,
  VaulBottomSheetShellProps
>(function VaulBottomSheetShell(
  { className, panelClassName, panelStyle, style, children, ...props },
  ref
) {
  return (
    <DrawerPrimitive.Content
      ref={ref}
      className={cn(
        VAUL_BOTTOM_SHEET_SAFE_OUTER_CLASSNAME,
        "fixed inset-x-0 bottom-0 z-[201] flex justify-center bg-transparent outline-none",
        className
      )}
      {...props}
    >
      <div
        className={cn(
          APP_CONTENT_SHELL_CLASSNAME,
          "relative flex flex-col outline-none",
          panelClassName
        )}
        style={{ ...panelStyle, ...(style as React.CSSProperties | undefined) }}
      >
        {children}
      </div>
    </DrawerPrimitive.Content>
  )
})
